import { render, staticRenderFns } from "./EditDApp.vue?vue&type=template&id=ab36c904&"
import script from "./EditDApp.vue?vue&type=script&lang=js&"
export * from "./EditDApp.vue?vue&type=script&lang=js&"
import style0 from "./EditDApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports